import Facets from './components/facets';
import 'selectize';
import AnimateHeight from './animateHeight';

class BaseDoc {
    init() {
        document.querySelectorAll('.tabs-docs').forEach((tab) => {
            tab.addEventListener('click', (event) => {
                const url = new URL(window.location.href);
                const a = event.target.closest('a');
                url.searchParams.set('tab', a.href.split('#')[1]);
                history.pushState({}, null, url.href);
            });
        });

        this.handleSelection();
        this.sortWithSelect();
        this.sortWithFacets();
        this.bindSubthemeToggle();
        this.syncSubthemeDisplay();
        this.initSubthemeDisplay();


        Facets.handleServiceAchatBtn();
    }

    sortWithSelect() {
        const url = new URL(window.location.href);
        // JQuery because selectize is used
        const $sortBySelect = $('#sort_by');

        const defaultOrderBy = url.searchParams.get("orderby");
        const defaultOrder = url.searchParams.get("order");

        let defaultSortBy = false;

        if (defaultOrder && defaultOrderBy) {
            defaultSortBy = defaultOrderBy + '_' + defaultOrder.toLowerCase();
        }

        if (defaultSortBy) {
            let $select = $sortBySelect.selectize();
            let selectize = $select[0].selectize;
            selectize.setValue(defaultSortBy, false);
        }

        $sortBySelect.on('change', (event) => {
            const url = new URL(window.location.href);
            Facets.sortBy(url, event.target.value);
        });
    }

    sortWithFacets() {
        const items = document.querySelectorAll('.facets-item');
        const self = this;

        if (items) {
            Array.prototype.filter.call(items, function (item) {
                item.addEventListener('click', (event) => {
                    event.stopPropagation();
                    let url = new URL(window.location.href);

                    if (event.target.classList.contains('facets-item')) {
                        url = Facets.setFilter(url, event.target, false);

                        if (event.target.classList.contains('input-theme')) {
                            let subthemeCheck = Facets.selectSubtheme(event.target);

                            Array.prototype.filter.call(subthemeCheck, function (subtheme) {
                                url = Facets.setFilter(url, subtheme, false);
                            });
                        }

                        let urlRequest = `${url.href}&is-json=true`;

                        if (url.href.indexOf('?') === -1) {
                            urlRequest = `${url.href}?is-json=true`;
                        }

                        Facets.applyFilterAjax(urlRequest);
                        self.handleSelection();
                    }
                });
            });
        }
    }

    handleSelection() {
        const items = document.querySelectorAll('.facets-item');
        const url = new URL(window.location.href);
        const self = this;

        if (items) {
            items.forEach(item => {
                Facets.applyFilter(url, item);

                const themeWrap = item.closest('.theme');

                if (!themeWrap) {
                    return;
                }

                const subitems = themeWrap.querySelectorAll('.input-subtheme');
                if (subitems) {
                    subitems.forEach(subitem => {
                        Facets.applyFilter(url, subitem);
                    });
                    self.syncSubthemeDisplay();
                }
            });
        }
    }

    syncSubthemeDisplay() {
        const subthemesList = document.querySelectorAll('.subtheme-list');

        for (const subthemeList of subthemesList) {
            const hasActive = subthemeList.querySelector('.input-subtheme.active');
            if (hasActive && subthemeList.getAttribute('data-collapsed') === 'true') {
                AnimateHeight.expandSection(subthemeList);
                subthemeList.setAttribute('data-collapsed', 'false');

                const button = subthemeList.parentElement.querySelector('.show-subtheme');
                if (button && button.classList.contains('show-more')) {
                    this.setShowSubthemeButtonState(button, 'show-less');
                }
            }
        }
    }

    bindSubthemeToggle() {
        const buttons = document.querySelectorAll('.show-subtheme');
        const self = this;

        for (const button of buttons) {
            if (button.dataset.subthemeBound === '1') {
                continue;
            }
            button.dataset.subthemeBound = '1';

            button.addEventListener('click', function () {
                const subthemeList = this.closest('.theme').querySelector('.subtheme-list');
                if (!subthemeList) {
                    return;
                }
                const isCollapsed = subthemeList.getAttribute('data-collapsed') === 'true';

                if (isCollapsed) {
                    AnimateHeight.expandSection(subthemeList);
                    subthemeList.setAttribute('data-collapsed', 'false');
                    self.setShowSubthemeButtonState(this, 'show-less');
                } else {
                    AnimateHeight.collapseSection(subthemeList);
                    subthemeList.setAttribute('data-collapsed', 'true');
                    self.setShowSubthemeButtonState(this, 'show-more');
                }
            });
        }
    }

    setShowSubthemeButtonState(button, state) {
        if (state === 'show-less') {
            button.innerHTML = `
                <svg class="mr-1" height="10" viewBox="0 0 30 30" width="10" xmlns="http://www.w3.org/2000/svg">
                    <path d="m0 12h30v5h-30z" fill="#004855" fill-rule="evenodd"/>
                </svg>
                Afficher moins`;
            button.classList.remove('show-more');
            button.classList.add('show-less');
        } else {
            button.innerHTML = `
                <svg class="mr-1" height="10" viewBox="0 0 30 30" width="10" xmlns="http://www.w3.org/2000/svg">
                    <g fill="#004855" fill-rule="evenodd"><path d="m0 12h30v5h-30z"/>
                        <path d="m13 0h5v30h-5z"/>
                    </g>
                </svg>
                Afficher les sous-thèmes`;
            button.classList.remove('show-less');
            button.classList.add('show-more');
        }
    }

    initSubthemeDisplay() {
        const showSubthemeBtns = document.querySelectorAll('.subtheme-list[data-collapsed="false"] + .show-subtheme');

        if (showSubthemeBtns) {

            for (const button of showSubthemeBtns) {

                if (button.classList.contains('show-more')) {
                    button.innerHTML = `
                                <svg class="mr-1" height="10" viewBox="0 0 30 30" width="10" xmlns="http://www.w3.org/2000/svg">
                                    <path d="m0 12h30v5h-30z" fill="#004855" fill-rule="evenodd"/>
                                </svg>
                                Afficher moins`
                    button.classList.remove('show-more');
                    button.classList.add('show-less');
                }
            }
        }
    }
}
export default new BaseDoc();
